module.exports = __webpack_public_path__ + "img/81,100,680.802459c9.svg";